import { render, staticRenderFns } from "./table64.vue?vue&type=template&id=4b5c9f75&scoped=true&"
import script from "./table64.vue?vue&type=script&lang=js&"
export * from "./table64.vue?vue&type=script&lang=js&"
import style0 from "./table64.vue?vue&type=style&index=0&id=4b5c9f75&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5c9f75",
  null
  
)

export default component.exports